module.exports = __webpack_public_path__ + "img/paidImg.576b23da.png";